
import { notification } from 'antd';

export const alert = (type, mesage) => {
    notification[type]({
        message: type === 'error' ? 'Đã có lỗi xảy ra': 'Thành công',
        description: mesage,
        duration: 2
    });
};